import { render, staticRenderFns } from "./charitiesAndNonProfits.vue?vue&type=template&id=24698c6b&scoped=true&"
import script from "./charitiesAndNonProfits.vue?vue&type=script&lang=js&"
export * from "./charitiesAndNonProfits.vue?vue&type=script&lang=js&"
import style0 from "./charitiesAndNonProfits.vue?vue&type=style&index=0&id=24698c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24698c6b",
  null
  
)

export default component.exports